import {DocumentStatus, DocumentType} from '@sollapay/enums';

export const DOCUMENT_MAX_FILES: Record<DocumentType, number> = {
  [DocumentType.LAND_OWNERSHIP_VERIFICATION]: 1,
  [DocumentType.TRUSTEE_INSTRUCTIONS]: 1,
  [DocumentType.TRANSACTION_LEGAL_DOCUMENT]: 10,
  [DocumentType.BUYER_REGISTRATION_FORM]: 1,
  [DocumentType.SIGNED_SALE_AGREEMENT]: 2,
  [DocumentType.SALE_AGREEMENT]: 1,
  [DocumentType.OPTION_AGREEMENT]: 1,
  [DocumentType.ASSIGNMENT_AGREEMENT]: 1,
  [DocumentType.INCORPORATION_CERTIFICATE]: 1,
  [DocumentType.AUTHORIZED_SIGNATORIES_PROTOCOL]: 1,
  [DocumentType.COMPANY_REGISTRATION_EXTRACT]: 1,
  [DocumentType.NATIONAL_ID_DOCUMENT]: 1,
  [DocumentType.PASSPORT_DOCUMENT]: 1,
  [DocumentType.ADDITIONAL_DOCUMENT]: 1,
  [DocumentType.FATCA_CRS_DECLARATION]: 1,
  [DocumentType.FATCA_CRS_SUPPLEMENTARY_DECLARATION]: 1000,
  [DocumentType.BANK_ACCOUNT_CONFIRMATION]: 1,
  [DocumentType.PAYMENT_DEMAND_DOCUMENT]: 1,
  [DocumentType.PAYMENT_VOUCHER]: 1,
  [DocumentType.UNKNOWN]: 1
};

export const getDocumentMaxFiles = (type: DocumentType): number => DOCUMENT_MAX_FILES[type];

export const isMultiFileDocumentType = (type: DocumentType): boolean =>
  DOCUMENT_MAX_FILES[type] > 1;

/**
 * Whether a document counts towards a readiness check. Shared by the server-side package
 * validators and the client-side "required document missing" hints so the two can't disagree.
 */
export const countsAsProvided = (document: {status: DocumentStatus}): boolean =>
  document.status === DocumentStatus.UPLOADED || document.status === DocumentStatus.VERIFIED;
